module.exports = __webpack_public_path__ + "img/linkedin.8af19fa5.svg";